import React, { Component } from 'react';
import { Button, Divider } from 'semantic-ui-react'
import * as moment from 'moment';
import axios from 'axios'
import * as FbUtils from '../../../../Utilities/FireBaseUtils'
import ImageUploader from '../../../newSite/ImageUploader'
import Status from '../../../../config/OrderStatusConstants.js'
import * as Utils from '../../../../Utilities/Utils'
import { getOrderKey, pythonApiIp  } from '../../../../config/constants';
import GetBackUpDesigns from './GetBackUpDesigns';


function ShowBackUpExists(props) {

    const show = props.order.designBackupUrl
        ? <div>
            <h5>Design backed up</h5>
            <GetBackUpDesigns order={props.order} />
            </div>
        : "NO DESIGN BACKED UP"

    return (
        <div>
            {show}
        </div>
    )
}


function UploadBackup(props) {
    //console.log("dsbx141 d.getTime():");

    var d = new Date();
   // console.log("dsbx142 d.getTime():"+d.getTime())

    
   // const upload = props.order.status === Status.start_dsng_kimoto || props.order.status === Status.fin_dsng_kimoto
    const upload = props.order.status !== Status.new 
        ? <Button basic color='purple' >
            UPLOAD DESIGN BACKUP
        <ImageUploader
                updateWhenFileUploadComplete={props.updateWhenFileUploadComplete}
                storageReference={'designBackup'}
                fileName={props.order.order_num + '_designBackup_'+d.getTime()} />
        </Button>
        : ""

    return (
        <div>
            {upload}
        </div>
    )
}


export default class DesignBackup extends Component {
    constructor(props) {
        super(props)

        this.state = ({
            kimotoUploadComplete: false
        })
    }

    kimotoNeeded = () => {
        console.log("++++++:kimotoNeeded");

        let kimotoStuff = {
            kimotoNeeded: true
        }

        let orderUpdate = {
            kimoto: kimotoStuff,
            kimotoNeeded: true
        }

        // FbUtils.updateOrder(this.props.order.key, orderUpdate);
    }



    updateWhenFileUploadComplete = (uploadComplete, actualFileName, url) => {
        console.log("dsbx1 ++++++++++:updateWhenFileUploadComplete");
        console.log("dsbx12 actualFileName:" + actualFileName);
        console.log("dsbx13 url:" + url);
        console.log("dsbx14 this.props.user.email:" + this.props.user.email);

   

        let now = moment().format('MMMM Do YYYY, h:mm:ss a');
        let orderUpdates = {
            designBackupUrl: url,
            designBackupUpdated: now,
            designBackupAddedBy: this.props.user.email,
            lastUpdatedBy:this.props.user.email
        }

        //FbUtils.updateOrder(this.props.order.key, orderUpdates);
        FbUtils.updateOrder(getOrderKey(this.props.order), orderUpdates);

        this.setState({
            designBackupComplete: true,
            actualFileName: actualFileName,
            designBackupImageUrl: url
        });
  
        this.saveAddDesignBackUp(url)
    }

    saveAddDesignBackUp = (url) => {
        console.log("dsbx15 ++++++++++++++: saveAddDesignBackUp");
        console.log("dsbx16 url:" + url);

        var d = new Date();
        console.log("dsbx17 d.getTime():"+d.getTime())

        let now = moment().format('MMMM Do YYYY, h:mm:ss a');
        let orderUpdates = {
            designBackUpSaved: 'yes',
            designBackUpSavedDate: now,
            designBackUpSavedAt: d.getTime()
        }

        FbUtils.updateOrder(getOrderKey(this.props.order), orderUpdates);

        axios.post(pythonApiIp + 'addDesignBackUp', {
            apiKey: "Psdfsdfasdf",
            fbOrderKey: getOrderKey(this.props.order),
            url: url,
            enteredBy:this.props.user.email
        })
            .then(function (response) {
                console.log(response.data);
                if(response.data.result){
                    alert(response.data.message)
                }else if(!response.data.result){
                    alert(response.data.message)
                }
            })
            .catch(function (error) {
                console.log(error);
                alert("Unable to savebackup on server")
            });

    }


    render() {

        const showAll = this.props.order.status !== Status.new 
            ? <div>
                <Divider horizontal>{'Design Backup'}</Divider>
                <ShowBackUpExists order={this.props.order}/>
                <UploadBackup
                    order={this.props.order}
                    updateWhenFileUploadComplete={this.updateWhenFileUploadComplete} />

            </div>
            : ""

        return (
            <div>
                {showAll}
            </div>
        )

    }
}


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/DesignBackup/DesignBackup.js